
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Users } from "lucide-react";

interface ReferrerBenefitsCardProps {
  formData: {
    referrer_bonus_value: string;
    referrer_multiplier: string;
    allow_bonus_accumulation: boolean;
  };
  updateFormField: (field: string, value: string | boolean) => void;
  isDisabled: boolean;
}

export const ReferrerBenefitsCard = ({ formData, updateFormField, isDisabled }: ReferrerBenefitsCardProps) => {
  return (
    <Card className="border-green-200 bg-green-50/30">
      <CardHeader className="pb-4">
        <div className="flex items-center gap-2">
          <Users className="h-5 w-5 text-green-600" />
          <div>
            <CardTitle className="text-lg text-green-900">Benefícios para quem Indica</CardTitle>
            <CardDescription className="text-green-700">
              Configure o bônus que o indicador receberá quando a primeira compra for realizada
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="referrer_bonus_value">Valor do Bônus (R$)</Label>
          <Input 
            id="referrer_bonus_value" 
            type="number" 
            step="0.01"
            min="0"
            placeholder="20.00" 
            value={formData.referrer_bonus_value}
            onChange={(e) => updateFormField('referrer_bonus_value', e.target.value)}
            disabled={isDisabled}
          />
          <p className="text-xs text-green-600">
            Bônus fixo para indicação
          </p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="referrer_min_purchase">Valor Mínimo para Usar Bônus (R$)</Label>
          <Input 
            id="referrer_min_purchase" 
            type="number" 
            step="0.01"
            min="0"
            placeholder="100.00" 
            value={formData.referrer_multiplier}
            onChange={(e) => updateFormField('referrer_multiplier', e.target.value)}
            disabled={isDisabled}
          />
          <p className="text-xs text-green-600">
            Compra mínima para usar bônus
          </p>
        </div>

        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <Switch 
              id="allow_bonus_accumulation" 
              checked={formData.allow_bonus_accumulation}
              onCheckedChange={(value) => updateFormField('allow_bonus_accumulation', value)}
              disabled={isDisabled}
            />
            <Label htmlFor="allow_bonus_accumulation">Permitir acumulação de bônus abaixo do valor mínimo</Label>
          </div>
          <p className="text-xs text-green-600">
            Acumular bônus abaixo do mínimo
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
